export const SALON_PHOTOS = {
  hero: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/ghapqari_20e4cb77-6973-466c-9c51-69ed3423f7a2_02-large.jpg",
  about: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/she8849p_022a536d-40f2-4ae7-85d4-6fd5120e11ab_06-large.jpg",
  services: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/dzwhf8mp_c645093e-1cfc-41f2-bd74-0c42228a0a5d_03-large.jpg",
  reviews: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/y5098y39_a9542a24-1ee3-446b-8882-8f27ebd7bfbe_04-large.jpg",
  contact: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/cc86du1k_befea250-ff1e-4bef-96bf-046a07b16c6b_07-large.jpg",
};

export const GALLERY_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/61m3n7wk_02279177-8388-4b9d-bd07-2aaf6e26c97f_08-large.jpg",
    alt: "Naša budova",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/s5qhf4bx_d080a7b6-d899-46a6-ba09-b2606e6f918a_01-large.jpg",
    alt: "Pohľad na salón",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/icu0skpt_d5a24117-47cd-4720-a876-b19ac78bdebb_05-large.jpg",
    alt: "Recepcia",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/iqmbop8u_02c38cf4-4ab9-4c62-89b7-cb64611f5513_10-large.jpg",
    alt: "Vchod do salónu",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/5z17wfg2_d018ebd8-fe33-4459-b156-cf9d0fcb4885_09-large.jpg",
    alt: "Žilinské námestie",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/dzwhf8mp_c645093e-1cfc-41f2-bd74-0c42228a0a5d_03-large.jpg",
    alt: "Stylingové stanovište",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_elegance-hair-lounge/artifacts/she8849p_022a536d-40f2-4ae7-85d4-6fd5120e11ab_06-large.jpg",
    alt: "Čakacia zóna",
    span: "",
  },
];

export const SALON_INFO = {
  name: "Luxury Salón",
  phone: "0918 800 348",
  phoneIntl: "+421918800348",
  address: "Hodžova 204/16, 010 01 Žilina",
  addressShort: "Hodžova 204/16, Žilina",
  notino: "https://www.notino.sk/salony/salon-luxury_1/",
  instagram: "https://www.instagram.com/salon_luxury_zilina/",
  googleReviews:
    "https://www.google.com/search?sca_esv=4a2b669a7127e47c&hl=sk-SK&q=recenzie+firmy+luxury+sal%C3%B3n&uds=ALYpb_ncDc7jTlmw6Mmq7NjuX5c-YEy0043y4jK-CyA28y9R2KVjVjfycKBxuGvpUbcIFL4rHbH9iZEItGrXreV4sWHzVV0tW89Vu96-vwstsY4ArZTMtloXCavSWw9h_qjhaWBdgwRq8YmpZwfUugI7pryGiRUQ4MoHRL2XEiI-5MGMWlYHLO_QZdbIoOzwvWVGBfALvFec",
  rating: "5,0",
  reviews: 23,
  mapEmbed:
    "https://www.google.com/maps?q=Hod%C5%BEova+204%2F16%2C+010+01+%C5%BDilina&output=embed",
};
